import React, { useEffect, useState } from 'react';

import BalanceView from './BalanceView';
import { useTranslation } from 'react-i18next';

const { Customer } = Mobi2Go;

const BalancesView = () => {
    const [t] = useTranslation('order.balances');
    const [balances, setBalances] = useState([]);
    const [hasBalanceProviders, setHasBalanceProviders] = useState(false);

    useEffect(() => {

        // We shouldn't update balances if the component gets unmounted before our async completes.
        let shouldSetBalances = true;

        const fetchCustomerBalances = async () => {
            try {
                const updatedBalances = await Customer.fetchBalances();

                if (shouldSetBalances) {
                    setBalances(updatedBalances.balances);

                    if (updatedBalances.hasOwnProperty('has_balance_providers')) {
                        setHasBalanceProviders(
                            updatedBalances.has_balance_providers
                        );
                    }
                }
            } catch (err) {
                throw err;
            }
        };

        fetchCustomerBalances()
            .catch(err => console.log(err))
        ;

        Customer.bind({
            logIn: fetchCustomerBalances,
            update: fetchCustomerBalances,
            updateBalances: fetchCustomerBalances
        });

        return () => {
            shouldSetBalances = false;

            Customer.unbind({
                logIn: fetchCustomerBalances,
                update: fetchCustomerBalances,
                updateBalances: fetchCustomerBalances
            });
        };
    }, []);

    if (!hasBalanceProviders) {
        return null;
    }

    const formatBalanceName = (name, index) => {
        return `${name.toLowerCase().replaceAll(' ', '-')}-${index}`;
    }

    return (
        <div className="m2g-customer-balances">
            {balances?.length === 0 && (
                <div className="m2g-customer-balances__none">{t('no_balances')}</div>
            )}
            {balances?.length > 0 &&
                balances.map((balance, index) => {
                    return (
                        <BalanceView
                            key={JSON.stringify(balance.reference)}
                            balance={balance}
                            formattedBalanceName={formatBalanceName(
                                balance.name,
                                index
                            )}
                        />
                    );
                })
            }
        </div>
    );
};

export default BalancesView;
